<template>
	<div id="importOrderDialog">
		<el-dialog 
			title="导入订单" 
			:visible.sync="isShowDialog"
			width="50%"
			:close-on-click-modal="false"
			@close="closeView">
			<el-row class='order_import_title'>
				请选择导入订单文件
			</el-row>
			<el-row class="order_import_wrap">
				<el-col class="order_import_file">
					<el-tooltip class="item" effect="dark" :content="uploadFileName" placement="top">
						<span >{{uploadFileName}}</span>
					</el-tooltip>	
				</el-col>
				<el-col class="order_import_btn_wrap">
					<el-upload :action="uploadUrl()" class="order_import_upload"
	                    accept=".xls"
	                    ref="upload"
	                    :data="data"
	                    :limit="1"
	                    :show-file-list="false"
	                    :auto-upload="false"
	                    :before-upload="beforeUpload"
	                    :on-change="change"
	                    :on-success="upLoadSuccess"
	                    :on-remove="uploadRemove">
	                    <el-button type="primary" >浏览</el-button>
	                    <!-- <div slot="tip" class="el-upload__tip">提示</div> -->
	                </el-upload>
				</el-col>
			</el-row>
			<div style="text-align: center;">
                <el-button type="primary" @click="uploadBeforeSave">导入订单</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>

export default {
	name: 'importOrderDialog',
	props: {
		isShow: Boolean,
	},
	data() {
		return {
			isShowDialog: false,
			uploadFileName: '',
			data: {
				token: localStorage.getItem("token"),
			},
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	mounted: function(){
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        uploadUrl(){
            return `/api/order/importOrder2?token=${localStorage.getItem("token")}`
        },
		closeView() {
			this.isShowDialog = false;
			this.$emit("update:isShow", this.isShowDialog);
			const upload = this.$refs.upload;
			if (upload != null) {
				upload.clearFiles();// 清空上传文件列表
			}
			this.uploadFileName = '';
		},
		uploadBeforeSave() {
			const upload = this.$refs.upload;
			if (upload.uploadFiles.length == 0) {
				this.$message.warning("请先选择要导入的订单");
				return;
			}
			upload.submit();
		},
		uploadRemove() {

		},
		upLoadSuccess(res, file, fileList) {
			if (res.code != 0) { // 上传失败
				if(res.code == 1001){
					let arr = res.data;
					let str = '';
					for(let i = 0 ; i < arr.length ; i++){
						str += ',' + arr[i];
					}
					str = str.substring(1);
					this.$message.warning('导入中止，存在重复订单编号：' + str);
				}else{
					this.$message.error(res.msg);
				}
				this.$RequestUtil.loading().close()
				this.$refs.upload.clearFiles();
				this.$nextTick(() => {
					this.uploadFileName = '';
				});
			}else{
				let message = "导入成功";
				let repeatCodeArr = res.data;
				if(repeatCodeArr != null && repeatCodeArr.length > 0){
					message += "，存在重复订单：";
					let str = "";
					for(let i = 0 ; i < repeatCodeArr.length ; i++){
						str += "，" + repeatCodeArr[i];
					}
					message += str.substring(1);
				}
				console.log('info',this.$parent, repeatCodeArr)
				this.$parent.exportInfo.url =  repeatCodeArr.url
                this.$parent.exportInfo.success =  repeatCodeArr.success
                this.$parent.exportInfo.fail =  repeatCodeArr.fail
                this.$parent.exportInfo.total = Number( repeatCodeArr.fail)+Number( repeatCodeArr.success)
                this.$parent.exportDialogVisible = true
				this.closeView();
				// this.$message.success(message);
				this.$parent.search(this.$parent.page.currentPage);
				this.$parent.orderRemoteMethod();
				this.$parent.loadstatusOrderCount()
				this.$store.commit('add_reloadPages',["/Production"])
			}
		},
		change(file, fileList){
			let name = file.name;
			if(!this.isFileValid(name)){
				const upload = this.$refs.upload;
				if (upload != null) {
					upload.clearFiles();// 清空上传文件列表
				}
				this.$message.error("只能上传xls或xlsx文件");
				return;
			}
			this.uploadFileName = name;
		},
		beforeUpload(file) {
			if (!this.isFileValid(file.name)) {
				this.$message.error("只能上传xls或xlsx文件");
				return false;
			}
			if (file.size > 1024 * 1024 * 10) {
				this.$message.error("文件不能大于10M");
				return false;
			}
			this.$RequestUtil.loading()
		},
		isFileValid(fileName){
			if(fileName.endsWith(".xls") || fileName.endsWith(".xlsx")){
				return true;
			}else{
				return false;
			}
		},
	},
	watch: {
		"isShow": function (newVal, oldVal) {
			this.isShowDialog = this.isShow;
		},
	},
}
</script>
<style scoped>
.order_import_title {
	text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-top: 0px;
}

.order_import_wrap {
	position: relative;
	margin: 40px 300px 20px 300px;
}

.order_import_file {
	width: 320px;
	height: 40px;
	line-height: 40px;
	border: 1px solid #ccc;
	padding-left: 10px;
	text-overflow: ellipsis;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}

.order_import_btn_wrap {
	width: 100px;
	height: 40px;
	position: absolute;
	left: 350px;
	display: flex;
}

.order_import_upload {
	width: auto;
	display: inline;
	position: absolute;
	top: 4px;
	left: 22px;
}

.order_info {
	margin: 20px 50px;
}

.order_confirm_title {
	font-size: 18px;
    font-weight: bold;
    margin: 5px 0px;
}

.order_info_item {
	margin: 5px 0px;
	font-size: 14px;
}

.order_info_label {
	display: inline-block;
	width: 100px;
}

.order_info_value {
	display: inline-block;
}

@media screen  {
	.order_import_title {
		text-align: center;
	    font-size: 20px;
	    font-weight: bold;
	    margin-top: 0px;
	}

	.order_import_wrap {
		margin: 30px 200px 30px 200px;
	}

	.order_import_file {
		width: 80%;
	}

	.order_import_btn_wrap {
		left: 85%;
	}
}
@media screen and (min-width: 1300px) and (max-width: 1930px){
   .order_import_title {
		text-align: center;
	    font-size: 20px;
	    font-weight: bold;
	    margin-top: 0px;
	}

	.order_import_wrap {
		margin: 30px 200px 30px 200px;
	}

	.order_import_file {
		width: 70%;
		margin-left: 15%
	}

	.order_import_btn_wrap {
		left: 88%;
	}
}
</style>


<style>
.order_part .el-scrollbar__wrap{
	height: 200px;
	overflow-x: hidden;
}

</style>


// WEBPACK FOOTER //
// src/views/importOrder/ImportOrderDialog.vue